<template>
    <div class="mb-5 pb-5" style="min-height: 800px;">
        <!-- <div class="input-group mt-0 align-items-stretch">
			<button class="input-group-prepend search-icon" @click="doSearch">
				<img :src="`${publicPath}/img/gep/icon/search.svg`">
			</button>
            <input type="text" :placeholder="$t('Search')" class="form-control no-border pl-2" v-model="search" v-on:keyup.enter="doSearch">
		</div> -->

        <blockAccount class="mb-5" v-if="data.length>0" v-for="(item,index) in data" :key="item.userNo" :ref="item.userNo" :item=item @viewDetail="viewDetail"></blockAccount>
        <div v-else class="text-center p-4 fz-20 text-grey7 fw-500">
            {{ $t('No history found') }}
        </div>

        <div v-if="isLoading" class="dot-loading mt-3 mb-5">
            <ul class="loader-circle">
                <li></li>
                <li></li>
                <li></li>
            </ul>
        </div>
    </div>
    
  </template>
  
  <script>
  import CreateAccount from '@/services/CreateAccount';
  import blockAccount from '@/components/blockAccount';

  const USER_TYPE = {
    1 : "Individual",
    2 : "China Enterprise",
    3 : "Hong Kong Enterprise",
    5 : "International Enterprise" 
  }
  
  export default {
    data() {
      return {
        publicPath: process.env.BASE_URL !== '/' ? process.env.BASE_URL : '',
        isLoading:false,
        data:[],
        search:'',
      };
    },
    components:{
        blockAccount
    },
    methods: {
        viewDetail(sub_account){
            this.$emit('viewDetail',sub_account);
        },
        doSearch(){

        },
    },
    mounted() {
        let self = this;
        this.$nextTick(() => {
            self.isLoading = true;
            CreateAccount.list({
                search:self.search,
                start:0,
                length:-1
            }).then((response)=>{
                if (response.status == 200) {
                    self.isLoading = false;
                    self.data = response.data.data;
                    
                    self.data.forEach(function(item,index) {
                        self.data[index]['txt_userType'] =  USER_TYPE[item.userType];
                        self.data[index]['enName'] = item.information.enName?item.information.enName:'';
                        self.data[index]['have_sub_account'] = item.status==2?true:false;
                        self.data[index]['show_balance'] = true;
                    });
                }
            });
        });
    },
    destroyed() {
      
    },
  };
  </script>
  
<style scoped>
.block-account{
    background: #F8F9FA;
    border-radius: 8px;
}
</style>